import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import ReactPlayer from "react-player";
import Image from "../Global/Image";
import Background from "../Global/Background";
import Slider from "react-slick";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function SlickPrevArrow(props) {
  const { onClick } = props;
  return (
    <span
      className="brand-slick-control brand-slick-control-prev fs-3 brand-cursor"
      onClick={onClick}
    >
      <FontAwesomeIcon icon="chevron-left" />
    </span>
  );
}
function SlickNextArrow(props) {
  const { onClick } = props;
  return (
    <span
      className="brand-slick-control brand-slick-control-next fs-3 brand-cursor"
      onClick={onClick}
    >
      <FontAwesomeIcon icon="chevron-right" />
    </span>
  );
}

const SectionGallery = (props) => {
  const { items } = props;
  const [activeSlide, setactiveSlide] = useState(0);

  const settings = {
    autoplay: false,
    infinite: true,
    dots: false,
    slidesToShow: 4,
    slidesToScroll: 4,
    nextArrow: <SlickNextArrow />,
    prevArrow: <SlickPrevArrow />,

    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
    ],
  };

  function YouTubeGetID(url) {
    url = url.split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
    return url[2] !== undefined ? url[2].split(/[^0-9a-z_\-]/i)[0] : url[0];
  }

  return (
    <section className="mb-5">
      <div className="row justify-content-center">
        <div className="col-12">
          <div className="ratio ratio-16x9 brand-background-black brand-text-white brand-radius">
            {items &&
              items.map((node, index) => {
                if (index === activeSlide) {
                  return (
                    <>
                      {node.video?.vimeo_raw || node.youtube ? (
                        <>
                          <ReactPlayer
                            url={node.video.vimeo_raw || node.youtube}
                            width="100%"
                            height="100%"
                            controls
                            config={{
                              youtube: {
                                playerVars: {
                                  autoplay: 0,
                                  playsinline: 1,
                                  color: "white",
                                  controls: 1,
                                  fs: 1,
                                  modestbranding: 1,
                                },
                              },
                              vimeo: {
                                playerOptions: {
                                  color: "ff007f",
                                  dnt: true,
                                  portrait: false,
                                  responsive: true,
                                  controls: true,
                                },
                              },
                            }}
                          />
                        </>
                      ) : (
                        <Image
                          src={node.image?.filename}
                          sm="300x0"
                          md="600x0"
                          lg="1920x1080"
                          className="w-100"
                          alt=""
                        />
                      )}
                    </>
                  );
                }
              })}
          </div>
        </div>
      </div>

      <Slider {...settings} className="brand-slick-slider mt-3">
        {items &&
          items.map((node, index) => {
            return (
              <div
                className={`h-100 brand-slick-slider-col brand-cursor ${
                  index === activeSlide ? "brand-slick-slider-col-active" : ""
                }`}
                onClick={() => setactiveSlide(index)}
              >
                {node.image?.filename ? (
                  <Image
                    src={node.image?.filename}
                    sm="256x0"
                    md="256x0"
                    lg="256x0"
                    className="w-100 brand-cursor brand-radius"
                    alt=""
                  />
                ) : node.video?.vimeo_oembed?.response
                    .thumbnail_url_with_play_button ? (
                  <img
                    src={
                      node.video?.vimeo_oembed?.response
                        .thumbnail_url_with_play_button
                    }
                    className="w-100 h-100 brand-cursor brand-radius"
                    alt=""
                  />
                ) : (
                  <div className="ratio ratio-16x9 w-100">
                    <div
                      className="brand-radius brand-background-black w-100 h-100 d-flex flex-column justify-content-center align-items-center brand-text-white brand-background-cover"
                      style={{
                        backgroundImage: `url(https://img.youtube.com/vi/${YouTubeGetID(
                          node.youtube
                        )}/0.jpg)`,
                      }}
                    >
                      <FontAwesomeIcon icon="play" />
                    </div>
                  </div>
                )}
              </div>
            );
          })}
      </Slider>
    </section>
  );
};

export default SectionGallery;

SectionGallery.propTypes = {
  items: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

SectionGallery.defaultProps = {
  items: null,
};
